// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_RevenueConciliationUnlinkRecebimentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/revenue_conciliation_unlink_recebimento/{period_id}/{recebimento_id}
 *
 * Unlinks a recebimento from a payroll period. No body required — both IDs are URL path parameters.
 */
import { registerContract } from './validate'

export interface Payroll_RevenueConciliationUnlinkRecebimentoInput {}

registerContract('Payroll_RevenueConciliationUnlinkRecebimentoInput', {})
